import { CLICK, component, demoFile, INPUT, story } from 'system/demo';
import { type Datastore } from 'util/datastore';
import { placeholderPhoto1, placeholderPhoto2, placeholderPhoto3, placeholderPhoto4, placeholderPhoto5 } from 'util/placeholders';
import { urlToKey } from 'util/util';

import { ContentPreview, ContentType, RelatedContent, RelatedContentEditScreenWidget } from '../related-content';

demoFile('feature/question/related-content', {
    designUrl: 'https://www.figma.com/design/5vqFJlKdA6UAQJeXYlMQW2/PSI-Stage-2?node-id=1-10840&m=dev',
});

const mockGlobals = {
    relatedContent: [
        {
            url: 'https://google.com/1',
            type: 'text',
            title: 'An article with a very long title that wraps onto multiple lines when shown in the preview and eventually needing to be truncated',
            image: placeholderPhoto1,
            date: 'Nov 2, 2024',
        },
        { url: 'https://google.com/2', type: 'media', title: 'Article 2', image: placeholderPhoto2, date: 'Jan 10, 2025' },
        { url: 'https://google.com/3', type: 'audio', title: 'Article 3', image: placeholderPhoto3, date: 'Feb 20, 2025' },
        { url: 'https://google.com/4', type: 'text', title: 'Article 4', image: placeholderPhoto4, date: 'Mar 10, 2025' },
        { url: 'https://google.com/5', type: 'media', title: 'Article 5', image: placeholderPhoto5, date: 'Apr 20, 2025' },
    ],
};

const moduleModulePublic = {
    article: {
        articleInfo: {
            [urlToKey('https://known.com/article')]: {
                title: 'The title of a known article',
                image: placeholderPhoto1,
                date: 'Nov 2, 2024',
            },
        },
    },
};

const mockServerCall = {
    constructor: {
        runConstructor: async (params: { datastore: Datastore; instanceKey: string }) => {
            // Simulate a URL that can't be parsed - return null for URLs containing "unparseable"
            if (params.instanceKey.includes('unparseable')) {
                // Don't set any article info, simulating a failed parse
                return;
            }

            await params.datastore.testOnlySetModulePublic(['article', 'articleInfo', params.instanceKey], {
                title: 'The title of a newly added article',
                image: placeholderPhoto2,
                date: 'Nov 5, 2022',
            });
        },
    },
};

component(
    'RelatedContent',
    RelatedContent,
    {
        state: {
            globals: mockGlobals,
        },
        instanceKey: 'test',
    },
    [story('Show more', [CLICK('Show more')])],
);

component('ContentPreview', ContentPreview, {
    args: {
        first: true,
        content: {
            url: 'https://google.com/1',
            type: 'text',
            title: 'An article with a very long title that wraps onto multiple lines when shown in the preview and eventually needing to be truncated',
            image: placeholderPhoto1,
            date: 'Nov 2, 2024',
        },
    },
    state: {
        globals: mockGlobals,
    },
});

component(
    'RelatedContentEditScreenWidget',
    RelatedContentEditScreenWidget,
    {
        state: {
            globals: mockGlobals,
            modulePublic: moduleModulePublic,
            serverCall: mockServerCall,
            roles: ['Editorial'],
        },
        instanceKey: 'test',
    },
    [
        story('Add known article', [CLICK('Add content'), INPUT('story-url', 'https://known.com/article'), CLICK('Add')]),
        story('Add unknown article', [CLICK('Add content'), INPUT('story-url', 'https://unknown.com/article'), CLICK('Add')]),
        story('Add unparseable article', [CLICK('Add content'), INPUT('story-url', 'https://unparseable.com/article'), CLICK('Add')]),
        story('Add invalid URL', [CLICK('Add content'), INPUT('story-url', 'not-a-valid-url'), CLICK('Add')]),
        story('Add URL without protocol', [CLICK('Add content'), INPUT('story-url', 'www.example.com'), CLICK('Add')]),
        story('Cancel add', [CLICK('Add content'), INPUT('story-url', 'https://example.com'), CLICK('Cancel')]),
    ],
);
